__turbopack_context__.v({
  "awardedBanner": "AbXpXa_awardedBanner",
  "moveBackground": "AbXpXa_moveBackground",
});
